import React from "react";
import { RotatingLines } from "react-loader-spinner";
import styled from "styled-components";

function Loading() {
  return (
    <p style={{ textAlign: "center", verticalAlign: "middle" }}>
      <Spinner>
        <RotatingLines width="100" strokeColor="#00263e" strokeWidth="2" />
      </Spinner>
    </p>
  );
}

const Spinner = styled.div`
  width: 100vw;
  height: 100vh;
  ${({ theme }) => theme.flexBox.flexMixin("column", "center", "center")}
`;

export default Loading;
